namespace RioERP.Web.Enums {
    export enum EmailEvents {
        CustomerOrderProcessed = 3,
        CustomerOrderShipped = 4,
        OrderReceiptAndBooks = 15
    }
    Serenity.Decorators.registerEnumType(EmailEvents, 'RioERP.Web.Enums.EmailEvents');
}
